const SvgNoResultsFound = (props) => (
  <svg
    width={241}
    height={206}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M123.7 165.64C161.317 165.64 191.889 135.068 191.889 97.4518C191.889 59.8354 161.317 29.2632 123.7 29.2632C85.9426 29.2632 55.5112 59.6945 55.5112 97.4518C55.5112 135.068 85.9426 165.64 123.7 165.64Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <path
      d="M80.7941 78.8115H163.221C166.307 78.8115 169.086 81.4356 169.086 84.6771V136.695C169.086 139.783 166.462 142.561 163.221 142.561H80.7941C77.707 142.561 74.9287 139.937 74.9287 136.695V84.6771C74.9287 81.4356 77.707 78.8115 80.7941 78.8115Z"
      fill="url(#paint0_linear_16810_37451)"
    />
    <path
      d="M203.018 80.4045C205.132 78.432 205.274 75.1917 203.301 73.0785C201.329 70.9652 198.088 70.8244 195.974 72.7967C193.862 74.7691 193.72 78.0094 195.693 80.1227C197.524 82.0951 200.906 82.3769 203.018 80.4045Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <path
      d="M203.3 57.1585C204.145 56.3131 204.287 54.9042 203.441 54.059C202.596 53.2136 201.187 53.0727 200.342 53.918C199.496 54.7634 199.355 56.1722 200.2 57.0175C201.046 58.0037 202.456 58.0037 203.3 57.1585Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <path
      d="M147.933 25.1774C148.496 24.6138 148.637 23.6276 148.073 23.0641C147.51 22.5005 146.523 22.3597 145.96 22.9231C145.397 23.4867 145.256 24.473 145.819 25.0364C146.383 25.6 147.369 25.7408 147.933 25.1774Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <g filter="url(#filter0_d_16810_37451)">
      <path
        d="M199.031 51.3359L178.502 87.9184C177.729 89.1532 176.187 89.6164 175.105 88.8446L139.913 68.3151C138.678 67.5433 138.215 65.9998 138.986 64.9192L165.998 18.3035C166.771 17.0686 168.315 16.6055 169.395 17.3773L194.863 32.1956L199.031 51.3359Z"
        fill="var(--kula-dark-secondary-50, #F2F6FA)"
      />
    </g>
    <path
      d="M194.863 32.1958L188.998 42.0746C188.226 43.6182 188.689 45.1617 190.079 46.0879L198.877 51.1817"
      fill="var(--kula-dark-secondary-50, #D5DAE6)"
    />
    <path
      d="M170.63 41.7661C171.246 41.6118 171.865 41.6118 172.328 41.6118C172.945 41.6118 173.563 41.6118 174.18 41.6118C174.798 41.7661 175.569 41.9204 176.187 42.0748C176.958 42.3836 177.576 42.6922 178.193 43.001C179.119 43.464 179.891 44.0815 180.508 44.8533C181.126 45.4707 181.59 46.2425 181.897 47.1686C182.206 47.9404 182.206 48.8666 182.206 49.6383C182.052 50.5645 181.743 51.4907 181.281 52.2624C180.817 53.0342 180.354 53.6516 179.737 54.269C179.119 54.7322 178.657 55.0408 177.884 55.3495C177.267 55.6582 176.649 55.8126 176.032 55.8126L174.334 55.9669C173.871 55.9669 173.408 56.1213 172.79 56.2757C172.328 56.4301 172.019 56.5843 171.71 56.8931L170.012 59.054L167.234 57.5105L168.469 54.7322C168.622 54.269 169.086 53.806 169.395 53.4972C169.859 53.1885 170.321 53.0342 170.784 52.8798C171.401 52.7255 171.865 52.7254 172.483 52.5711C173.099 52.5711 173.717 52.4167 174.334 52.2624C174.952 52.1081 175.414 51.9537 176.032 51.6449C176.649 51.3363 176.958 50.8731 177.267 50.2557C177.422 49.947 177.576 49.484 177.729 49.021C177.729 48.5578 177.729 48.249 177.576 47.9404C177.422 47.4773 177.267 47.1686 176.958 46.8599C176.649 46.5512 176.342 46.2425 175.878 45.9337C175.414 45.6251 174.798 45.3163 174.18 45.1619C173.717 45.0075 173.254 45.0075 172.79 45.0075C172.328 45.0075 172.019 45.0075 171.71 45.0075C171.555 45.0075 171.246 45.0075 171.093 44.8533C170.784 44.6989 170.475 44.2358 170.475 43.9271L170.63 41.7661ZM162.757 62.1413C162.912 61.8325 163.221 61.5238 163.529 61.2151C163.838 61.0607 164.147 60.752 164.456 60.752C165.227 60.5976 166 60.5976 166.616 61.0607C166.925 61.2151 167.234 61.5238 167.542 61.8325C167.697 62.1413 167.851 62.4499 168.006 62.7587C168.469 64.3022 167.542 65.6914 166 66.1546C165.227 66.3088 164.456 66.1546 163.838 65.8458C163.529 65.6914 163.221 65.3828 162.912 65.074C162.757 64.7652 162.448 64.4566 162.448 64.1478C162.294 63.8391 162.294 63.3761 162.448 63.0673C162.448 62.7587 162.603 62.4499 162.757 62.1413Z"
      fill="var(--kula-dark-secondary-100, #CED6E2)"
    />
    <g filter="url(#filter1_d_16810_37451)">
      <path
        d="M67.0563 35.4374L90.5185 59.9801C91.2902 60.9063 91.2902 62.1411 90.3642 62.9128L66.4389 85.6034C65.5127 86.3752 64.2778 86.3752 63.506 85.449L33.5609 53.8058C32.7891 52.8798 32.7891 51.6448 33.7152 50.8731L51.1575 34.5112L67.0563 35.4374Z"
        fill="var(--kula-dark-secondary-50, #F2F6FA)"
      />
    </g>
    <path
      d="M51.0032 34.2021L57.4861 40.9939C58.4123 41.9199 59.9559 41.9199 60.882 40.9939L66.902 35.2827"
      fill="var(--kula-dark-secondary-50, #D5DAE6)"
    />
    <path
      d="M52.8555 55.3501C52.8555 54.8869 53.0099 54.4239 53.1642 53.9607C53.3186 53.4977 53.473 53.0346 53.6272 52.5716C53.7816 52.1086 54.0904 51.6454 54.3992 51.1824C54.7078 50.7193 55.1709 50.2562 55.6339 49.7931C56.2513 49.1757 56.8687 48.7127 57.6407 48.4039C58.258 48.0952 59.0298 47.9409 59.6472 47.9409C60.2646 47.9409 61.0364 48.0952 61.6539 48.2495C62.2713 48.5583 62.8887 49.0213 63.5061 49.4845C63.9692 49.9475 64.4323 50.5649 64.5866 51.1824C64.741 51.6454 64.8954 52.2628 65.0498 52.8803C65.0498 53.3433 65.0498 53.9607 65.0498 54.4239C64.8954 54.8869 64.8954 55.3501 64.741 55.8131C64.741 56.2761 64.5866 56.5848 64.5866 57.048C64.5866 57.3566 64.5866 57.6654 64.8954 57.974L66.1302 59.8263L64.2779 61.5243L62.4257 59.8263C62.1169 59.5177 61.8082 59.2089 61.6539 58.7458C61.4995 58.2828 61.4995 57.974 61.4995 57.511C61.4995 57.048 61.6539 56.5848 61.6539 56.1218C61.8082 55.6587 61.8082 55.1957 61.8082 54.7325C61.8082 54.2695 61.8082 53.8065 61.6539 53.3433C61.4995 52.8803 61.1908 52.4172 60.8821 51.9542C60.7278 51.6454 60.419 51.491 60.1104 51.3368C59.8016 51.1824 59.4928 51.1824 59.1842 51.1824C58.8754 51.1824 58.5667 51.3368 58.258 51.491C57.9493 51.6454 57.6407 51.7998 57.3319 52.1086C57.0231 52.4172 56.7145 52.8803 56.4057 53.189C56.2513 53.4977 56.097 53.8064 55.9427 54.2695C55.7883 54.5783 55.7883 54.8869 55.7883 55.0413C55.7883 55.1957 55.6339 55.3501 55.4796 55.5043C55.3252 55.8131 54.8622 55.8131 54.5534 55.6587L52.8555 55.3501ZM67.0564 66.1549C66.902 66.0007 66.7476 65.6919 66.5933 65.3831C66.439 65.0745 66.439 64.7657 66.439 64.4571C66.439 63.8396 66.7476 63.2222 67.2107 62.7592C67.3651 62.6048 67.6737 62.4504 67.9825 62.296C68.2913 62.1416 68.5999 62.1416 68.9087 62.1416C69.8348 62.1416 70.761 62.7592 71.0696 63.6852C71.224 63.994 71.224 64.3027 71.224 64.6114C71.224 64.9201 71.0696 65.2289 71.0696 65.5375C70.9152 65.8463 70.761 66.0007 70.4522 66.3093C70.2978 66.4637 69.9891 66.7725 69.6804 66.7725C69.0631 66.9268 68.4455 66.9268 67.9825 66.7725C67.5195 66.6181 67.2107 66.4637 67.0564 66.1549Z"
      fill="var(--kula-dark-secondary-100, #CED6E2)"
    />
    <g filter="url(#filter2_d_16810_37451)">
      <path
        d="M128.336 74.0267L119.229 106.596C118.92 107.677 117.685 108.448 116.605 107.985L84.9617 98.7238C83.8813 98.4152 83.1095 97.1803 83.5725 96.0997L95.9211 54.1148C96.2298 53.0342 97.4646 52.2624 98.5451 52.7254L121.544 59.5172L128.336 74.0267Z"
        fill="var(--kula-dark-secondary-50, #F2F6FA)"
      />
    </g>
    <path
      d="M121.547 59.5742L118.611 68.7785C118.303 70.0133 119.075 71.4026 120.309 71.7113L128.45 74.0117"
      fill="var(--kula-dark-secondary-50, #D5DAE6)"
    />
    <path
      d="M104.102 72.0198C104.565 71.8654 105.028 71.7111 105.491 71.5568C105.954 71.4024 106.418 71.248 107.035 71.248C107.652 71.248 108.115 71.248 108.733 71.248C109.35 71.248 109.968 71.4024 110.585 71.5568C111.357 71.7111 112.129 72.1742 112.746 72.6372C113.364 73.1004 113.827 73.5634 114.29 74.1808C114.598 74.7983 114.907 75.4157 115.061 76.0331C115.216 76.8049 115.061 77.5766 114.907 78.1942C114.753 78.8116 114.444 79.429 113.981 80.0463C113.672 80.5095 113.209 80.9725 112.746 81.2813C112.283 81.5899 111.82 81.8987 111.357 82.0531L109.968 82.5161C109.659 82.6704 109.196 82.8248 108.887 82.9792C108.578 83.1336 108.27 83.4422 108.27 83.751L107.344 85.7576L104.874 84.6772L105.337 82.2074C105.337 81.7443 105.646 81.4357 105.954 81.1269C106.263 80.8181 106.572 80.5095 107.035 80.3551C107.498 80.2007 107.961 80.0464 108.27 79.8921C108.733 79.7377 109.196 79.5833 109.659 79.2746C110.122 79.1202 110.431 78.8116 110.894 78.5028C111.203 78.1942 111.511 77.731 111.666 77.1136C111.666 76.9592 111.666 76.6505 111.666 76.3419C111.666 76.0331 111.511 75.7245 111.357 75.4157C111.203 75.1069 110.894 74.9527 110.585 74.6439C110.276 74.4895 109.968 74.3351 109.505 74.1808C109.041 74.0265 108.578 74.0265 107.961 74.0265C107.652 74.0265 107.189 74.0265 106.881 74.1808C106.572 74.1808 106.263 74.3351 106.109 74.3351C105.954 74.3351 105.8 74.4895 105.491 74.3351C105.183 74.3351 104.874 74.0265 104.874 73.7178L104.102 72.0198ZM101.787 89.7708C101.941 89.4622 101.941 89.1534 102.25 88.999C102.404 88.6904 102.713 88.536 102.867 88.3816C103.485 88.073 104.102 88.073 104.565 88.2273C104.874 88.3816 105.183 88.536 105.337 88.6904C105.491 88.8448 105.8 89.1534 105.954 89.3078C106.572 90.3883 106.109 91.7775 105.028 92.2405C104.411 92.5493 103.793 92.5493 103.33 92.3949C103.022 92.2405 102.713 92.2405 102.558 91.9319C102.25 91.7775 102.095 91.4687 101.941 91.3145C101.787 91.0057 101.787 90.8514 101.632 90.5426C101.787 90.3884 101.787 90.0796 101.787 89.7708Z"
      fill="var(--kula-dark-secondary-100, #CED6E2)"
    />
    <g filter="url(#filter3_d_16810_37451)">
      <path
        d="M202.736 129.749L172.79 145.956C171.865 146.419 170.475 146.111 170.012 145.03L155.04 115.857C154.576 114.93 154.885 113.541 155.965 113.078L194.863 92.5487C195.79 92.0857 197.18 92.3944 197.642 93.4748L208.447 114.622L202.736 129.749Z"
        fill="var(--kula-dark-secondary-50, #F2F6FA)"
      />
    </g>
    <path
      d="M208.293 114.931L199.957 119.253C198.877 119.871 198.415 121.414 198.877 122.495L202.581 129.904"
      fill="var(--kula-dark-secondary-50, #D5DAE6)"
    />
    <path
      d="M187.609 110.918C188.073 111.072 188.38 111.381 188.844 111.536C189.308 111.69 189.615 111.999 190.079 112.462C190.542 112.925 190.85 113.233 191.159 113.696C191.623 114.159 191.932 114.623 192.239 115.24C192.703 115.857 192.857 116.784 192.857 117.401C193.012 118.173 192.857 118.79 192.857 119.562C192.703 120.179 192.394 120.797 192.085 121.414C191.623 122.032 191.004 122.495 190.388 122.804C189.924 123.112 189.153 123.267 188.535 123.421C188.073 123.575 187.3 123.575 186.837 123.421C186.374 123.267 185.756 123.267 185.294 122.958L184.059 122.34C183.75 122.186 183.287 122.032 182.978 121.877C182.67 121.723 182.206 121.723 182.052 122.032L180.046 122.804L178.966 120.488L180.972 119.099C181.281 118.79 181.743 118.79 182.206 118.79C182.67 118.79 182.978 118.79 183.441 118.944C183.905 119.099 184.212 119.408 184.521 119.562C184.985 119.716 185.294 120.025 185.911 120.179C186.374 120.334 186.683 120.334 187.3 120.488C187.764 120.488 188.226 120.334 188.844 120.025C189.308 119.716 189.924 119.253 189.924 118.481C190.079 118.173 189.924 117.864 189.924 117.401C189.77 117.092 189.77 116.784 189.461 116.321C189.308 115.857 188.998 115.549 188.689 115.086C188.535 114.931 188.226 114.623 187.918 114.468C187.764 114.314 187.455 114.159 187.3 114.005C187.146 113.851 186.991 113.851 186.837 113.542C186.683 113.388 186.683 112.925 186.837 112.77L187.609 110.918ZM173.254 121.569C173.563 121.414 173.718 121.26 174.18 121.414C174.489 121.26 174.798 121.414 174.952 121.414C175.569 121.569 176.033 122.032 176.187 122.495C176.342 122.804 176.342 123.112 176.342 123.421C176.342 123.575 176.342 124.038 176.342 124.193C176.187 124.656 175.723 125.273 175.26 125.428C174.952 125.582 174.643 125.582 174.334 125.582C174.18 125.582 173.718 125.582 173.563 125.582C172.945 125.428 172.483 124.964 172.328 124.501C172.174 124.193 172.174 123.884 172.174 123.575C172.019 123.267 172.174 122.958 172.174 122.804C172.328 122.495 172.483 122.34 172.483 122.032C172.636 121.877 173.099 121.877 173.254 121.569Z"
      fill="var(--kula-dark-secondary-100, #CED6E2)"
    />
    <path
      d="M170.63 112.307V137.931C170.63 141.172 167.851 143.951 164.61 143.951H79.868C76.6265 143.951 73.848 141.172 73.848 137.931V110.146"
      stroke="#1676EE"
      strokeWidth={4.37349}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M167.388 95.7905H138.369C135.591 95.7905 132.812 96.7167 130.651 98.5689L122.933 104.743C120.772 106.441 117.994 107.522 115.216 107.522H82.1832C78.9417 107.522 76.1633 110.146 76.1633 113.542C76.1633 113.85 76.1633 114.159 76.3177 114.468L82.3375 146.111C82.8007 149.044 85.4246 151.359 88.3575 151.359H158.899C161.986 151.359 164.456 149.198 164.918 146.265L173.408 102.737C173.871 99.495 171.71 96.4079 168.315 95.9448C168.006 95.7905 167.697 95.7905 167.388 95.7905Z"
      fill="var(--kula-dark-secondary-200, white)"
    />
    <g filter="url(#filter4_d_16810_37451)">
      <path
        d="M175.414 90.0796H140.839C137.598 90.0796 134.202 91.3144 131.732 93.3211L122.471 100.885C119.846 103.046 116.605 104.126 113.363 104.126H73.6938C69.835 104.126 66.4391 107.213 66.4391 111.381C66.4391 111.689 66.4391 112.153 66.5933 112.461L73.8482 150.897C74.4656 154.446 77.3983 157.225 81.103 157.225H165.227C168.777 157.225 171.865 154.601 172.483 151.051L182.516 98.4149C183.132 94.5559 180.508 90.697 176.496 90.0796C176.187 90.0796 175.724 90.0796 175.414 90.0796Z"
        fill="url(#paint1_linear_16810_37451)"
      />
    </g>
    <path
      d="M108.733 130.52C110.739 130.52 112.437 128.823 112.437 126.816C112.437 124.809 110.739 123.111 108.733 123.111C106.726 123.111 105.028 124.809 105.028 126.816C105.028 128.823 106.726 130.52 108.733 130.52Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M137.597 129.904C139.604 129.904 141.302 128.206 141.302 126.2C141.302 124.193 139.604 122.495 137.597 122.495C135.591 122.495 133.893 124.193 133.893 126.2C133.893 128.206 135.591 129.904 137.597 129.904Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M130.96 136.078H128.953C127.255 132.682 123.088 131.293 119.846 133.145C118.457 133.762 117.377 134.997 116.914 136.078H114.907C116.605 131.602 121.699 129.286 126.021 130.984C128.336 131.91 130.034 133.762 130.96 136.078Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M189.461 169.727C187.764 169.727 188.38 169.882 175.26 156.762C162.603 166.178 145.006 157.071 145.006 141.635C145.006 131.293 153.496 122.803 163.838 122.803C178.811 122.803 188.071 139.628 179.273 152.439L191.468 164.634C193.474 166.487 192.239 169.727 189.461 169.727ZM163.992 128.823C156.891 128.823 151.026 134.534 151.026 141.789C151.026 149.044 156.738 154.756 163.992 154.756C164.763 154.756 165.536 154.756 166.307 154.601C167.08 154.446 167.851 154.292 168.469 153.983C169.24 153.674 169.857 153.366 170.475 153.057C171.246 152.594 171.865 152.131 172.481 151.513C172.945 151.051 173.563 150.433 174.025 149.969C174.489 149.353 174.952 148.735 175.26 148.118C175.569 147.5 175.878 146.729 176.187 145.957C176.495 145.185 176.649 144.413 176.649 143.641C176.649 143.024 176.804 142.561 176.804 141.943C176.958 134.534 171.092 128.823 163.992 128.823Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M99.6257 120.488L107.961 116.012"
      stroke="var(--kula-dark-secondary-300, #989FB0)"
      strokeWidth={2.18675}
      strokeMiterlimit={10}
    />
    <path
      d="M144.852 118.327L136.517 113.696"
      stroke="var(--kula-dark-secondary-300, #989FB0)"
      strokeWidth={2.18675}
      strokeMiterlimit={10}
    />
    <defs>
      <filter
        id="filter0_d_16810_37451"
        x={106.537}
        y={0.963856}
        width={124.567}
        height={136.366}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={16.0361} />
        <feGaussianBlur stdDeviation={16.0361} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_16810_37451"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_16810_37451"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_16810_37451"
        x={0.927711}
        y={18.4751}
        width={122.224}
        height={115.797}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={16.0361} />
        <feGaussianBlur stdDeviation={16.0361} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_16810_37451"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_16810_37451"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_16810_37451"
        x={51.3631}
        y={36.5522}
        width={109.045}
        height={119.679}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={16.0361} />
        <feGaussianBlur stdDeviation={16.0361} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_16810_37451"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_16810_37451"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_16810_37451"
        x={122.759}
        y={76.3042}
        width={117.761}
        height={117.969}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={16.0361} />
        <feGaussianBlur stdDeviation={16.0361} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_16810_37451"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_16810_37451"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_16810_37451"
        x={34.3668}
        y={74.0434}
        width={180.311}
        height={131.29}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={16.0361} />
        <feGaussianBlur stdDeviation={16.0361} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_16810_37451"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_16810_37451"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_16810_37451"
        x1={122.007}
        y1={83.4983}
        x2={122.007}
        y2={107.596}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--kula-dark-secondary-100, #B0BACC)" />
        <stop offset={1} stopColor="var(--kula-dark-secondary-300, #969EAE)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_16810_37451"
        x1={124.484}
        y1={88.5264}
        x2={124.484}
        y2={157.948}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--kula-dark-secondary-200, #FDFEFF)" />
        <stop
          offset={0.9964}
          stopColor="var(--kula-dark-secondary-50, #ECF0F5)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNoResultsFound;
